export const profileTypesReducer = (state = {loading: true, resultprofileType: null, profileTypes: null, profileType: null } , action) => {
    switch (action.type) {
        case 'PROFILETYPE_GETALL_SUCCESS':
            return {
                ...state,
                loading:false,
                profileTypes: action.payload
            }
        case 'PROFILETYPE_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                resultprofileType: action.payload
            }
        case 'PROFILETYPE_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                resultprofileType: action.payload
            }
        case 'PROFILETYPE_RESET_RESULT':
            return {...state,
                resultprofileType: null
            }
        case 'PROFILETYPE_REMOVE_RESULT':
            return {...state,
                loading:false,
                resultprofileType: action.payload.message,
                profileTypes: state.profileTypes.filter(profileTypes => profileTypes._id !== action.payload.idProfileType)
            }
        case 'PROFILETYPE_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PROFILETYPE_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

